import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'dislivellonegativo'
})

export class DislivelloNegativoPipe implements PipeTransform {
    /**in base al parametro passato si setta il livello di dislivello negativo
     * @param  {number} value
     */
    transform(value: number): string {
        let distanza: string = '<i class="fas fa-sort-down" title="Dislivello negativo"></i> ' +  (value == null ? '0' : value.toString()) + ' m';
        return distanza;
    }
}